import { createContext, useContext } from "react";

interface IframeContextProps {
  iframeDocument: Document | null;
  class_name: any;
}
const IframeDocumentContext = createContext<IframeContextProps>({
  iframeDocument: null,
  class_name: null
});

export const useIframeDocument = () => {
  const context = useContext(IframeDocumentContext);
  if (context === null) {
    throw new Error(
      "useIframeDocument must be used within an IframeDocumentProvider"
    );
  }
  return context;
};

export const IframeDocumentProvider = IframeDocumentContext.Provider;
